import { ExperienceCategory } from '@/generated/graphql';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { ClickAwayListener, Grid, MenuList, Paper, useMediaQuery } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { useExploreQuery } from '../hooks/use-explore-query';
import useSetCategory from '../hooks/use-set-category';
import ButtonAvatar, { AvatarImage } from './button-avatar';
import StyledButton, {
  StyledButtonGroup,
  StyledGrow,
  StyledMenuItem,
  StyledPopper,
} from './dropdown-button';
const options = [
  ExperienceCategory.Taste,
  ExperienceCategory.Make,
  ExperienceCategory.Move,
  ExperienceCategory.Connect,
  ExperienceCategory.Explore,
  ExperienceCategory.Advocate,
];
const NewActivityFilterButton = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const searchParams = useSearchParams();
  const category = searchParams?.get('category');
  const setCategory = useSetCategory();
  const { refetch } = useExploreQuery();
  const handleMenuItemClick = async (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    if (options[index] === category) {
      setCategory(undefined);
    } else {
      setCategory(options[index]);
      setOpen(false);
      await refetch();
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClick = () => {
    if (category) {
      setCategory(undefined);
    } else {
      handleToggle();
    }
  };
  const checkCategory = () => {
    if (category) {
      return <CloseIcon style={{ color: 'black' }} />;
    }
    return <KeyboardArrowDown style={{ color: 'black' }} />;
  };

  const handleClose = () => {
    setOpen(false);
  };
  const isMobile = useMediaQuery('(max-width: 960px');
  const defaultText = isMobile ? 'Interest' : 'Choose by interest';
  const selected = category !== undefined && category !== null;
  return (
    <Grid container direction="column" alignItems="center" style={{ width: 'auto' }}>
      <Grid item xs={12}>
        <StyledButtonGroup
          variant="contained"
          ref={anchorRef}
          className={selected ? 'selected' : ''}
        >
          <StyledButton onClick={handleClick}>
            {selected && (
              <ButtonAvatar style={{ marginRight: 10, width: 30, height: 30 }}>
                <AvatarImage src={`/tasks/${category?.toString().toLocaleLowerCase()}/group.png`} />
              </ButtonAvatar>
            )}
            {category || defaultText}
            {checkCategory()}
          </StyledButton>
        </StyledButtonGroup>
        <StyledPopper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps }) => (
            <StyledGrow {...TransitionProps}>
              <Paper style={{ width: 'max-content' }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" style={{ paddingTop: 12, paddingBottom: 12 }}>
                    {options.map((option, index) => (
                      <StyledMenuItem
                        key={option}
                        selected={selected}
                        onClick={event => handleMenuItemClick(event, index)}
                        divider={index < options.length - 1}
                      >
                        <ButtonAvatar style={{ marginRight: 10, width: 30, height: 30 }}>
                          <AvatarImage src={`/tasks/${option.toLowerCase()}/group.png`} />
                        </ButtonAvatar>
                        {option}
                      </StyledMenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </StyledGrow>
          )}
        </StyledPopper>
      </Grid>
    </Grid>
  );
};
export default NewActivityFilterButton;
